<template>
  <Message class="message-bind" v-if="showSuccessMessage" autoDashboardRedirect>
    <img class="message-bind_icon" slot="icon" src="../common/components/Message/icon_success.svg" alt="$t('Упс')" />
    <template v-slot:message>
      <p v-html="successMessage"></p>
      <p v-html="recommendDepositMessage"/>
    </template>
  </Message>
  <Binding v-else :selectedGame="selectedGame" @showSuccessMessage="onShowSuccessMessage" @selectGame="onSelectGame" />
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { TheMask } from 'vue-the-mask'
import { namespace, State } from 'vuex-class'

import { getDepositUrl } from '@/helpers'
import { gameNames, gameTitles } from '@/constants'
import Binding from '@/components/Binding'
import Button from '@/common/components/Button'
import Message from '@/common/components/Message'

const auth = namespace('auth')

@Component({ components: { Binding, TheMask, Button, Message } })
class CardBindView extends Vue {
  @State('country') currentCountry
  @auth.State(({ user }) => user.name) userAccount

  selectedGame = gameNames.GAME_MT
  showSuccessMessage = false
  tag = null

  onShowSuccessMessage (tag) {
    this.showSuccessMessage = true
    this.tag = tag
  }

  onSelectGame (game) {
    this.$analytics.trackBindPageClickSelectGame({ screenId: this.$route.name })
    this.selectedGame = game
  }

  get depositUrl () {
    return getDepositUrl(this.tag)
  }

  get successMessage () {
    return this.$t(`Карта успешно привязана к аккаунту %(nickname)s в игре %(game)s.`, {
      nickname: `<span class="message-bind_nickname">${this.userAccount}</span>`,
      game: this.$t(gameTitles[this.selectedGame].name)
    })
  }

  get recommendDepositMessage () {
    return this.$t(
      '%(link_start)sПополни баланс%(link_stop)s карты онлайн без комиссии',
      { link_start: `<a class="link" href="${this.depositUrl}">`, link_stop: `</a>` }
    )
  }
}

export default CardBindView
</script>

<style lang="scss">
.message-bind {
  &_icon {
    height: 120px;
    width: 120px;
    margin: 34px 0;
    @include media_tablet {
      height: 150px;
      width: 150px;
      margin: 72px 0;
    }
  }
  &_nickname {
    color: #ff0033;
  }
}
</style>
